import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=2192709c&"
import script from "./pack.vue?vue&type=script&lang=js&"
export * from "./pack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2192709c')) {
      api.createRecord('2192709c', component.options)
    } else {
      api.reload('2192709c', component.options)
    }
    module.hot.accept("./pack.vue?vue&type=template&id=2192709c&", function () {
      api.rerender('2192709c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/pack.vue"
export default component.exports